<template> 

  <modal name="addCustomerModal" height="auto" :scrollable=true @opened="onOpened" @before-open="beforeModalOpen" @before-close="beforeModalClose">
  <br><br>
  <div class="card">

    <div class="col-sm-12" style="display:inline-block;">
      <div>
        <div class="form-group">
          <h4 class="card-title">Add Contact</h4>
        </div>

        <form @submit.prevent="validateBeforeSubmit" v-if="!modal_formSubmitted">

          <div class="card-body">
            <div class="row form">

              <div class="col-12">
              </div>


              <div class="col-12 col-sm-12">
                <div class="form-group">
                  <label for="modal_email">Email</label>
                  <input type="email" id="modal_email" name="modal_email" v-on:keyup="contactLiveSearch()" autocomplete="new-password" v-model="modal_email" class="form-control" v-validate="'required|email'" data-vv-as="email" data-vv-delay="1000" :class="{'input':true, 'is-danger': errors.has('modal_email') }">
                  <div id="contactCustomLiveSearch" class="customLiveSearch">
                    <template v-for="row in contactrows">
                      <div class="customLiveSearchElement" v-on:click="contactSelected(row)">{{ row.display }}</div>
                    </template>
                  </div>
                </div>
              </div>

              <div class="col-12 col-sm-6">
                <div class="form-group">
                  <label for="modal_name">Name</label>
                  <input type="text" id="modal_name" name="modal_name" v-model="modal_name" class="form-control" v-validate="'required|min:2'" data-vv-as="name" data-vv-delay="1000" :class="{'input': true, 'is-danger': errors.has('modal_name') }" disabled="true" >
                </div>
              </div>

              <div class="col-12 col-sm-6">
                <div class="form-group">
                  <label for="phone">Phone Office</label>
                  <input type="text" id="modal_phoneoffice" name="modal_phoneoffice" v-model="modal_phoneoffice" class="form-control" disabled="true" >
                </div>
              </div>

             <div class="col-12 col-sm-6">
                <div class="form-group">
                  <label for="phone">Phone Cell</label>
                  <input type="text" id="modal_phonecell" name="modal_phonecell" v-model="modal_phonecell" class="form-control" disabled="true" >
                </div>
              </div>

              <div class="col-12 col-sm-6">
                <div class="form-group">
                  <label for="phone">Fax</label>
                  <input type="text" id="modal_fax" name="modal_fax" v-model="modal_fax" class="form-control" disabled="true" >
                </div>
              </div>


              <div class="col-12 col-sm-6">
                <div class="form-group">
                  <label for="phone">Position Description</label>
                  <input type="text" id="modal_position" name="modal_position" v-model="modal_position" class="form-control" disabled="true" >
                </div>
              </div>

              <div class="col-12 col-sm-6">
                <div class="form-group">

                </div>
              </div>


              <div class="col-12 col-sm-6">
                <div class="form-group">
                  <label for="modal_company">Company</label>
                  <input type="text" id="modal_company" name="modal_company" v-on:keyup="companyLiveSearch()" v-model="modal_company" class="form-control" disabled="true">
                  <div id="companyLiveSearch" class="customLiveSearch">
                    <template v-for="row in companyrows">
                      <div class="customLiveSearchElement" v-on:click="companySelected(row)">{{ row.display }}</div>
                    </template>
                  </div>
                </div>
              </div>

              <div class="col-12 col-sm-6">
                <div class="form-group">
                  <label for="modal_division">Division</label>
                  <input type="text" id="modal_division" name="modal_divison" v-model="modal_division" v-on:keyup="divisionChange()" class="form-control" disabled="true">
                </div>
              </div>


              <div class="col-12">
                <div class="form-group">
                  <label for="modal_phone">Address</label>
                  <input type="text" id="modal_full_address" name="modal_full_address" class="form-control" disabled="true" @input="validatingFullAddress = true" onfocus="this.setAttribute('autocomplete', 'new-password');">
                </div>
              </div>

              <div class="col-12">
                <div class="form-group">
                  <LeafletMap v-if="hasAddressLocation" height="200px" :starting-center="mapCenter" :points="addressMapPoint" />
                </div>
              </div>

              <div class="col-12 col-sm-6">
                <div class="form-group">
                  <label for="modal_phone">Street Address</label>
                  <input type="text" id="modal_address" name="modal_address" v-model="modal_address" class="form-control" disabled="true">
                </div>
              </div>

              <div class="col-12 col-sm-6">
                <div class="form-group">
                  <label for="modal_postal">City</label>
                  <input type="text" id="modal_city" name="modal_city" v-model="modal_city" class="form-control" disabled="true">
                </div>

              </div>

              <div class="col-12 col-sm-6">
                <div class="form-group">
                  <label for="modal_province">State / Province</label>
                  <select id="modal_province" class="form-control" v-model="modal_province" v-on:change="onProvinceChange(modal_province)" style="-webkit-appearance: none; -webkit-border-radius: 0px;" disabled="true">
                    <option value="">Select One</option>
                    <optgroup label="Canadian Provinces">
                      <option value="AB">Alberta</option>
                      <option value="BC">British Columbia</option>
                      <option value="MB">Manitoba</option>
                      <option value="NB">New Brunswick</option>
                      <option value="NF">Newfoundland and Labrador</option>
                      <option value="NT">Northwest Territories</option>
                      <option value="NS">Nova Scotia</option>
                      <option value="NU">Nunavut</option>
                      <option value="ON">Ontario</option>
                      <option value="PE">Prince Edward Island</option>
                      <option value="QC">Quebec</option>
                      <option value="SK">Saskatchewan</option>
                      <option value="YT">Yukon Territory</option>
                    </optgroup>
                    <optgroup label="U.S. States/Territories">
                      <option value="AK">Alaska</option>
                      <option value="AL">Alabama</option>
                      <option value="AR">Arkansas</option>
                      <option value="AZ">Arizona</option>
                      <option value="CA">California</option>
                      <option value="CO">Colorado</option>
                      <option value="CT">Connecticut</option>
                      <option value="DC">District of Columbia</option>
                      <option value="DE">Delaware</option>
                      <option value="FL">Florida</option>
                      <option value="GA">Georgia</option>
                      <option value="HI">Hawaii</option>
                      <option value="IA">Iowa</option>
                      <option value="ID">Idaho</option>
                      <option value="IL">Illinois</option>
                      <option value="IN">Indiana</option>
                      <option value="KS">Kansas</option>
                      <option value="KY">Kentucky</option>
                      <option value="LA">Louisiana</option>
                      <option value="MA">Massachusetts</option>
                      <option value="MD">Maryland</option>
                      <option value="ME">Maine</option>
                      <option value="MI">Michigan</option>
                      <option value="MN">Minnesota</option>
                      <option value="MO">Missouri</option>
                      <option value="MS">Mississippi</option>
                      <option value="MT">Montana</option>
                      <option value="NC">North Carolina</option>
                      <option value="ND">North Dakota</option>
                      <option value="NE">Nebraska</option>
                      <option value="NH">New Hampshire</option>
                      <option value="NJ">New Jersey</option>
                      <option value="NM">New Mexico</option>
                      <option value="NV">Nevada</option>
                      <option value="NY">New York</option>
                      <option value="OH">Ohio</option>
                      <option value="OK">Oklahoma</option>
                      <option value="OR">Oregon</option>
                      <option value="PA">Pennsylvania</option>
                      <option value="PR">Puerto Rico</option>
                      <option value="RI">Rhode Island</option>
                      <option value="SC">South Carolina</option>
                      <option value="SD">South Dakota</option>
                      <option value="TN">Tennessee</option>
                      <option value="TX">Texas</option>
                      <option value="UT">Utah</option>
                      <option value="VA">Virginia</option>
                      <option value="VT">Vermont</option>
                      <option value="WA">Washington</option>
                      <option value="WI">Wisconsin</option>
                      <option value="WV">West Virginia</option>
                      <option value="WY">Wyoming</option>
                    </optgroup>
                  </select>
                </div>
              </div>

              <div class="col-12 col-sm-6">

                <div class="form-group">
                  <label for="addContact_postalzip">Postal / Zip</label>
                  <input type="text" id="modal_postal" name="modal_postal" v-model="modal_postal" class="form-control" disabled="true">
                </div>

              </div>

              <div class="col-12 col-sm-6">
                <div class="form-group">
                  <label for="modal_country">Country</label>
                  <select id="modal_country" class="form-control" v-model="modal_country" style="-webkit-appearance: none; -webkit-border-radius: 0px;" disabled="true" >
                    <option>Canada</option>
                    <option>United States</option>
                  </select>
                </div>
              </div>

              <div class="col-12 col-sm-6">
                <div class="form-group">
                  <label for="modal_phone">Phone Number</label>
                  <input type="text" id="modal_phone" name="modal_phone" v-model="modal_phone" class="form-control" disabled="true">
                </div>
              </div>

              <div class="col-12 col-sm-6">
                <div class="form-group">
                  <label for="modal_website">Website</label>
                  <input type="text" id="modal_website" name="modal_website" v-model="modal_website" class="form-control" disabled="true">
                </div>
              </div>


            </div>
          </div>

          <div class="app-error">{{ modal_errorMessage }}</div>
          <br />
          <div class="form-group form-actions">
            <button type="button" class="btn btn-default" v-on:click="hideCustomerModal()">Cancel</button>
            <button type="submit" class="btn btn-success">Add Contact</button>
          </div>

          <p v-show="errors.has('modal_name')" class="help is-danger">{{ errors.first('modal_name') }}</p>
          <p v-show="errors.has('modal_email')" class="help is-danger">{{ errors.first('modal_email') }}</p>
          <p v-show="!hasCoordinates && validatingFullAddress" class="help is-danger">Could not find address coordinates. The address field is required.</p>


        </form>

      </div>
    </div>
    <div class="col-sm-2"style="display:inline-block;"></div>
  </div>
  </modal>

</template>


<script>

import Vue from 'vue'
import apiService from '../services/api.service'
import { AddressAutocompleteMixin } from '../utils/mixins/address-auto-complete.mixin';
import * as ModalMutationTypes from '../store/modules/modal/modal.types';

import VeeValidate from 'vee-validate'
Vue.use(VeeValidate)
var error = ''

//auto-complete for contact name
var contactrows = [ ]

//auto-complete for company
var companyrows = [ ]

export default {
  name: 'contactmodal',
  mixins: [ AddressAutocompleteMixin ],
  data: function () {
    return {
      contactrows: contactrows,
      companyrows: companyrows,
      modal_errorMessage: '',
      modal_id: '',
      modal_name: '',
      modal_email: '',
      modal_phoneoffice: '',
      modal_phonecell: '',
      modal_fax: '',
      modal_position: '',
      modal_type: 'Person',
      modal_website: '',
      modal_address: '',
      modal_postal: '',
      modal_city: '',
      modal_province: '',
      modal_country: '',
      modal_company: '',
      modal_division: '',
      modal_phone: '',
      modal_formSubmitted: false,
      validatingFullAddress: false
    }
  },
  computed: {
    hasCoordinates() {
      return this.addressCoordinates.lat !== null && this.addressCoordinates.lng !== null;
    }
  },
  methods: {


    onProvinceChange(prov)
    {
      console.log("prov change!");
      if (prov == "AB" || prov == "BC" || prov == "MB" || prov == "NB" || prov == "NF" || prov == "NT" || prov == "NS" || prov == "NU" || prov == "ON" || prov == "PE" || prov == "QC" || prov == "PE" || prov == "QC" || prov == "SK" || prov == "YT")
      {
        this.country = "Canada";
      }
      else
      {
        this.country = "United States";
      }
    },



   contactLiveSearch: function (event) {

      console.log("contactLiveSearch");
      var entry = this.modal_email
      console.log("auto: " + entry);
      if (entry.length < 3) {
        document.getElementById('contactCustomLiveSearch').style.display = 'none'
      } else {

        // Find Matches
        apiService.post('/kong/api/v1/entity/globalemail/',  "", { headers: { 'X-Search': entry }}) // this.$cookie.get('apikey')}
        .then(function (response) {

          //disable form
          document.getElementById("modal_name").disabled = true;
          document.getElementById("modal_phoneoffice").disabled = true;
          document.getElementById("modal_phonecell").disabled = true;
          document.getElementById("modal_fax").disabled = true;
          document.getElementById("modal_position").disabled = true;

          document.getElementById("modal_company").disabled = true;
          document.getElementById("modal_division").disabled = true;
          document.getElementById("modal_phone").disabled = true;
          document.getElementById("modal_full_address").disabled = true;
          document.getElementById("modal_address").disabled = true;
          document.getElementById("modal_postal").disabled = true;
          document.getElementById("modal_city").disabled = true;
          document.getElementById("modal_province").disabled = true;
          document.getElementById("modal_country").disabled = true;
          document.getElementById("modal_website").disabled = true;


          // Pop everything off
          while(contactrows.length > 0) contactrows.pop();

          console.log( "results: " + response.data.Result.length );
          contactrows.push({email: "", name: "Add New", id: "-1", display: "Add New"})
          for (var i = 0; i < response.data.Result.length; i++) {

            var customerRow = {
            id: response.data.Result[i].id,
            email: response.data.Result[i].email, 
            name: response.data.Result[i].name,
            phoneoffice: response.data.Result[i].phoneoffice, 
            phonecell: response.data.Result[i].phonecell, 
            fax: response.data.Result[i].fax, 
            position: response.data.Result[i].position, 
            type: response.data.Result[i].type,
            company: response.data.Result[i].company,
            division: response.data.Result[i].division, 
            phone: response.data.Result[i].phone, 
            website: response.data.Result[i].website, 
            fullAddress: response.data.Result[i].fullAddress, 
            address: response.data.Result[i].address, 
            postal: response.data.Result[i].postal, 
            city: response.data.Result[i].city,
            province: response.data.Result[i].province, 
            country: response.data.Result[i].country,
            addressCoordinates: response.data.Result[i].addressCoordinates,
            display: response.data.Result[i].name
            };

            if (customerRow.email != null) customerRow.display += ", " + customerRow.email;
            if (customerRow.company != null && customerRow.company.length > 0) customerRow.display += ", " + customerRow.company;
            if (customerRow.division != null && customerRow.division.length > 0) customerRow.display += " - " + customerRow.division;
            if (customerRow.city != null) customerRow.display += ", " + customerRow.city;

            contactrows.push(customerRow);
          }
          document.getElementById('contactCustomLiveSearch').style.display = 'block'
        })
        .catch(function (error) {
          console.log('contact auto complete error: ' + JSON.stringify(error))
          while(contactrows.length > 0) contactrows.pop();
          contactrows.push({email: "", name: "Add New", id: "-1", display: "Add New"})
          document.getElementById('contactCustomLiveSearch').style.display = 'block'
        })
        // Sort it all
        contactrows.sort()
      }
    },


    contactSelected: function (row) {

      console.log("-----------contactSelected");
      // this.$parent.$options.methods.testModal(row.id);

      if (row.id == "-1")
      {
        document.getElementById('contactCustomLiveSearch').style.display = 'none'
        console.log("add new so enable full form");
        document.getElementById("modal_name").removeAttribute("disabled");
        document.getElementById("modal_phoneoffice").removeAttribute("disabled");
        document.getElementById("modal_phonecell").removeAttribute("disabled");
        document.getElementById("modal_fax").removeAttribute("disabled");
        document.getElementById("modal_position").removeAttribute("disabled");

        document.getElementById("modal_company").removeAttribute("disabled");
        document.getElementById("modal_division").removeAttribute("disabled");
        document.getElementById("modal_phone").removeAttribute("disabled");
        document.getElementById("modal_full_address").removeAttribute("disabled");
        document.getElementById("modal_address").removeAttribute("disabled");
        document.getElementById("modal_postal").removeAttribute("disabled");
        document.getElementById("modal_city").removeAttribute("disabled");
        document.getElementById("modal_province").removeAttribute("disabled");
        document.getElementById("modal_country").removeAttribute("disabled");
        document.getElementById("modal_website").removeAttribute("disabled");


        this.modal_id = "";
        this.modal_name = "";
        this.modal_phoneoffice = "";
        this.modal_phonecell = "";
        this.modal_fax = "";
        this.modal_position = "";
        this.modal_company = "";
        this.modal_division = "";
        this.modal_phone = "";
        this.modal_address = "";
        this.modal_postal = "";
        this.modal_city = "";
        this.modal_province = "";
        this.modal_country = "";
        this.modal_website = "";

      }
      else
      {
        console.log( JSON.stringify(row) );
        document.getElementById('contactCustomLiveSearch').style.display = 'none'
        this.modal_id = row.id;
        this.modal_name = row.name
        this.modal_email = row.email

        this.modal_phoneoffice = row.phoneoffice
        this.modal_phonecell = row.phonecell
        this.modal_fax = row.fax
        this.modal_position = row.position

        this.modal_company = row.company
        this.modal_division = row.division
        this.modal_phone = row.phone
        this.modal_website = row.website
        this.fullAddress = row.fullAddress
        this.modal_address = row.address
        this.modal_postal = row.postal
        this.modal_city = row.city
        this.modal_province = row.province
        this.modal_country = row.country
        this.addressCoordinates = row.addressCoordinates
      }
    },


   companyLiveSearch: function (event) {

      console.log("companyLiveSearch");
      var entry = this.modal_company
      console.log("auto: " + entry);
      if (entry.length < 2) {
        document.getElementById('companyLiveSearch').style.display = 'none'
        this.modal_phone = "";
        this.modal_address = "";
        this.modal_postal = "";
        this.modal_city = "";
        this.modal_province = "";
        this.modal_country = "";
        this.modal_website = "";
        this.modal_division = "";
      } else {

        // Find Matches
        apiService.post('/kong/api/v1/company/globalsearch/', "", { headers: { 'X-Search': entry }})
        .then(function (response) {


          // Pop everything off
          while(companyrows.length > 0) companyrows.pop();

          console.log( "results: " + response.data.Result.length );
          for (var i = 0; i < response.data.Result.length; i++) {
            var companyRow = {
              id: response.data.Result[i].id,
              company: response.data.Result[i].company,
              division: response.data.Result[i].division,
              phone: response.data.Result[i].phone, 
              fullAddress: response.data.Result[i].fullAddress, 
              address: response.data.Result[i].address, 
              postal: response.data.Result[i].postal, 
              city: response.data.Result[i].city,
              province: response.data.Result[i].province, 
              country: response.data.Result[i].country,
              addressCoordinates: response.data.Result[i].addressCoordinates,
              website: response.data.Result[i].website,
              display: response.data.Result[i].company
            };

            if (companyRow.division != null && companyRow.division.length > 0) companyRow.display += " - " + companyRow.division;
            companyrows.push(companyRow);
          }
          document.getElementById('companyLiveSearch').style.display = 'block'
        })
        .catch(function (error) {
          console.log('company auto complete error: ' + JSON.stringify(error))
          while(companyrows.length > 0) companyrows.pop();
          document.getElementById('companyLiveSearch').style.display = 'block'
        })
        // Sort it all
        companyrows.sort()

        //they are typing a new company, enable form
        document.getElementById("modal_phone").removeAttribute("disabled");
        document.getElementById("modal_full_address").removeAttribute("disabled");
        document.getElementById("modal_address").removeAttribute("disabled");
        document.getElementById("modal_postal").removeAttribute("disabled");
        document.getElementById("modal_city").removeAttribute("disabled");
        document.getElementById("modal_province").removeAttribute("disabled");
        document.getElementById("modal_country").removeAttribute("disabled");
        document.getElementById("modal_website").removeAttribute("disabled");
      }
    },

    companySelected: function (row) {
      console.log("-----------companySelected");
      console.log( JSON.stringify(row) );
      document.getElementById('companyLiveSearch').style.display = 'none'
      this.modal_phone = row.phone
      this.fullAddress = row.fullAddress
      this.modal_address = row.address
      this.modal_postal = row.postal
      this.modal_city = row.city
      this.modal_province = row.province
      this.modal_country = row.country
      this.addressCoordinates = row.addressCoordinates
      this.modal_website = row.website
      this.modal_company = row.company
      this.modal_company_entity = row.id;
      this.modal_division = row.division

      //disable lower part of form when existing company selected
      document.getElementById("modal_phone").disabled = true;
      document.getElementById("modal_full_address").disabled = true;
      document.getElementById("modal_address").disabled = true;
      document.getElementById("modal_postal").disabled = true;
      document.getElementById("modal_city").disabled = true;
      document.getElementById("modal_province").disabled = true;
      document.getElementById("modal_country").disabled = true;
      document.getElementById("modal_website").disabled = true;
    },

    divisionChange: function() {
      document.getElementById('companyLiveSearch').style.display = 'none'

      //they are typing a new division, enable form and clear address fields
      document.getElementById("modal_phone").removeAttribute("disabled");
      document.getElementById("modal_full_address").removeAttribute("disabled");
      document.getElementById("modal_address").removeAttribute("disabled");
      document.getElementById("modal_postal").removeAttribute("disabled");
      document.getElementById("modal_city").removeAttribute("disabled");
      document.getElementById("modal_province").removeAttribute("disabled");
      document.getElementById("modal_country").removeAttribute("disabled");
      document.getElementById("modal_website").removeAttribute("disabled");

      this.modal_phone = "";
      this.fullAddress = "";
      this.modal_address = "";
      this.modal_postal = "";
      this.modal_city = "";
      this.modal_province = "";
      this.modal_country = "";
      this.addressCoordinates = {
        lat: null,
        lng: null,
      };
      this.modal_website = "";

    },




    hideCustomerModal: function () {
      this.$modal.hide('addCustomerModal')
    },
    beforeModalOpen (event) {
      console.log("beforeModalOpen");
      this.$store.dispatch(ModalMutationTypes.OPEN_CONTACT);
    },
    onOpened(){
      $(document).ready(function() {
        $('input').attr('autocomplete', 'new-password');
      });
      this.GoogleMapsApi.useAutocomplete('modal_full_address', (autocomplete) => {
        const fullAddress = this.GoogleMapsApi.getFullAddressString(autocomplete);
        
        const addressComponents = this.GoogleMapsApi.getAddressComponents(autocomplete);
        console.log("Place Changed addressComponents", addressComponents);
        this.fullAddress = fullAddress;
        this.modal_address = addressComponents.address;
        this.modal_city = addressComponents.city;
        this.modal_province = addressComponents.province;
        this.modal_postal = addressComponents.postal;
        this.modal_country = addressComponents.country;

        const addressCoordinates = this.GoogleMapsApi.getAddressCoordinates(autocomplete);
        this.addressCoordinates = {
          lat: addressCoordinates.lat,
          lng: addressCoordinates.lng,
        }
      }).catch(e => {
        console.error("Error Initializing Autocomplete", e);
      });
    },
    beforeModalClose (event) {
      console.log("beforeModalClose")
      this.GoogleMapsApi.cleanupAutocomplete('modal_full_address');
      this.validatingFullAddress = false;
      //console.log(this.company + " --> " + this.modal_name)

      //finally clear the modal
      clearTextBoxes(this);
      this.$store.dispatch(ModalMutationTypes.CLOSE_CONTACT);
    },


    validateBeforeSubmit(e) {
      console.log("validateBeforeSubmit()");
      this.validatingFullAddress = true;
      this.$validator.validateAll();
      if (!this.errors.any() && this.hasCoordinates) {
          this.formSubmitted = true;
          this.addContact();
      }
      else {
        console.log("Validation: " + JSON.stringify(this.errors));
      }
    },


    addContact: function (event) {
      console.log("addContact()");
      var rootObj = this;
     
      var existingEntityId = this.modal_id
      var passed_email = this.modal_email


      if (this.modal_postal == null || this.modal_postal.length == 0)
      {
        Vue.toasted.error("Please enter a postal code for this contact.", { duration: 3500 })
        return
      }
      if (this.modal_city == null || this.modal_city.length == 0)
      {
        Vue.toasted.error("Please enter a city for this contact.", { duration: 3500 })
        return
      }
      if (this.modal_company == null || this.modal_company.length == 0)
      {
        if (this.modal_division != null && this.modal_division.length > 0)
        {
          Vue.toasted.error("Please enter a parent company for this division.", { duration: 3500 })
          return
        }
      }

      // Sent API request
      apiService.post('/kong/api/v1/entity/', {
        name: this.modal_name,
        email: this.modal_email,
        phoneoffice: this.modal_phoneoffice,
        phonecell: this.modal_phonecell,
        fax: this.modal_fax,
        position: this.modal_position,
        type: this.modal_type,
        website: this.modal_website,
        phone: this.modal_phone,
        fullAddress: this.fullAddress,
        address: this.modal_address,
        postal: this.modal_postal,
        city: this.modal_city,
        province: this.modal_province,
        country: this.modal_country,
        addressCoordinates: this.addressCoordinates,
        company: this.modal_company,
        division: this.modal_division })
      .then(function (response) {

        console.log("add success");
        console.log(JSON.stringify(response));
        rootObj.modal_id = response.data.Result.id;

        // fill in the correct section of this RFQ with the new contact info
        // TODO use a prop and enforce this populateFromContactModal 'interface' ?

        rootObj.$parent.$emit('populateContact', rootObj);

        //rootObj.$parent.$options.methods.populateFromContactModal(rootObj.modal_id, rootObj);

        // If successful add the relationship
        apiService.put('/kong/api/v1/entity/relationship/', {
          email: passed_email })
        .then(function (response) {

          // If successful fill in the customer name and notify the user
          console.log("Link Success");
          Vue.toasted.success("Successfully Linked Contact", { duration: 3500 })
          rootObj.$modal.hide('addCustomerModal')
        })
        .catch(function (error) {
          // Otherwise inform them of the issue
          console.log("add error");
          Vue.toasted.error(JSON.stringify(error), { duration: 3500 })
        })
      })
      .catch(function (error) {

        console.log( "Warning: " + JSON.stringify(error) );
        if (error.response != null && error.response.data != null && error.response.data.Result == "Sorry, the user already exists") {

          // Link a contact if they already exist in the database
          apiService.put('/kong/api/v1/entity/relationship/', { email: passed_email })
          .then(function (response) {
            console.log( JSON.stringify(response) );

            rootObj.$parent.$emit('populateContact', rootObj);

            Vue.toasted.success("Successfully Linked Contact", { duration: 3500 })
            rootObj.$modal.hide('addCustomerModal')
          })
          .catch(function (error) {
            console.log( error );
            Vue.toasted.error("There was a problem linking this contact.", { duration: 3500 })
          })
          
        }
        else {
          Vue.toasted.error("There was a problem adding the contact.", { duration: 3500 })
        }

      })

    },

  }
}

function clearTextBoxes(vm)
{
  console.log("clearing modal vars...")
  vm.modal_id = "";
  vm.modal_name = "";
  vm.modal_email = "";
  vm.modal_phoneoffice = "";
  vm.modal_phonecell = "";
  vm.modal_fax = "";
  vm.modal_position = "";
  vm.modal_website = "";
  vm.modal_phone = "";
  vm.fullAddress = "";
  vm.modal_postal = "";
  vm.modal_city = "";
  vm.modal_province = "";
  vm.modal_country = "";
  vm.addressCoordinates = {
    lat: null,
    lng: null,
  };
  vm.modal_company = "";
  vm.modal_division = "";
}


</script>


// WEBPACK FOOTER //
// ContactModal.vue?7b0dcf06